import React, { useState } from 'react';
import { 
  Moon, Book, Clock, Sun, Heart, Star, Coffee, Menu, X, BedDouble, Zap, 
  Baby, Stethoscope, Sparkles, Bath, UserPlus, BadgeHelp, Thermometer,
  Brain, MessageCircle, Milk, Droplets, Wind
} from 'lucide-react';
import NavBar from './NavBar';
import babyImage1 from './baby-image1.jpg'; // Importer plus d'images de bébés
import babyImage2 from './baby-image2.jpg';
import babyImage3 from './baby-image3.jpg';
import babyImage4 from './baby-image4.jpg';
import babyImage5 from './baby-image5.jpg';
import babyImage6 from './baby-image6.jpg';
import babyImage7 from './baby-image7.jpg';
import babyImage8 from './baby-image8.jpg';
import babyImage9 from './baby-image9.jpg';
import babyImage10 from './baby-image10.jpg';
import babyImage11 from './baby-image11.jpg';
import babyImage12 from './baby-image12.jpg';
import babyImage13 from './baby-image13.jpg';
import babyImage14 from './baby-image14.jpg';
import babyImage15 from './baby-image15.jpg';
import babyImage16 from './baby-image16.jpg';
import babyImage17 from './baby-image17.jpg';
import babyImage18 from './baby-image18.jpg';


const ConseilsPage = () => {
  const [activeCategory, setActiveCategory] = useState('bebes');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const categories = {
    bebes: {
      title: "Soins des Bébés",
      tips: [
        {
          title: "Premiers Jours",
          content: "L'adaptation à la vie extra-utérine est une phase sensible. Nous vous guidons sur les soins du cordon, le bain enveloppé et les rythmes spécifiques du nouveau-né.",
          icon: Baby,
          image: babyImage1
        },
        {
          title: "Alimentation",
          content: "Que vous ayez choisi l'allaitement ou le biberon, nous vous accompagnons dans cette découverte : position optimale, rythmes à respecter et conseils pratiques.",
          icon: Milk,
          image: babyImage2
        },
        {
          title: "Sommeil du Nouveau-né",
          content: "Comprendre et respecter les cycles du sommeil de votre bébé est essentiel. Apprenez à reconnaître ses signes de fatigue et à mettre en place une routine apaisante.",
          icon: Moon,
          image: babyImage3
        }
      ]
    },
    problematiques: {
      title: "Solutions Pratiques",
      tips: [
        {
          title: "Coliques et RGO",
          content: "Solutions pour soulager les coliques : positions spécifiques, massages doux du ventre. Pour le RGO, nous vous conseillons sur les positions adaptées pendant et après les repas. Consultez un pédiatre si les symptômes persistent.",
          icon: Stethoscope,
          image: babyImage7
        },
        {
          title: "Soins Quotidiens",
          content: "Conseils pour gérer : poussée dentaire, érythème fessier, canal lacrymal obstrué et rhume chez le tout-petit. Des solutions douces et efficaces pour le confort de bébé.",
          icon: Bath,
          image: babyImage8
        },
        {
          title: "Comprendre les Pleurs",
          content: "Décryptage des différents types de pleurs de bébé et utilisation des bruits blancs pour l'apaiser. Chaque pleur a sa signification et nous vous aidons à les reconnaître.",
          icon: MessageCircle,
          image: babyImage9
        }
      ]
    },
    sommeil: {
      title: "Conseils Sommeil",
      tips: [
        {
          title: "Mise en place des Rythmes",
          content: "Dès les premières semaines, vous pouvez aider votre bébé à distinguer le jour et la nuit. Lumière naturelle le jour, atmosphère calme et tamisée le soir.",
          icon: Moon,
          image: babyImage10
        },
        {
          title: "Les Signes de Fatigue",
          content: "Apprenez à repérer les signes spécifiques chez le nourrisson : frottement des yeux, bâillements, regard fuyant, agitation. Couchez votre bébé dès les premiers signes.",
          icon: BedDouble,
          image: babyImage11
        },
        {
          title: "Accompagnement au Coucher",
          content: "Techniques douces pour accompagner l'endormissement : bercement, fredonnement, toucher apaisant. Créez une routine constante qui sécurise votre tout-petit.",
          icon: Clock,
          image: babyImage12
        }
      ]
    },
    ateliers: {
      title: "Nos Ateliers",
      tips: [
        {
          title: "Massage Bébé",
          content: "Apprenez les techniques spécifiques de massage pour apaiser votre bébé, soulager les coliques, favoriser son développement sensoriel et renforcer le lien parent-enfant.",
          icon: Heart,
          image: babyImage13
        },
        {
          title: "Bain Thérapeutique",
          content: "Découvrez les bienfaits du bain enveloppant : relaxation profonde, soulagement des tensions, meilleure qualité de sommeil et moment privilégié avec votre bébé.",
          icon: Bath,
          image: babyImage14
        },
        {
          title: "Atelier Portage",
          content: "Initiez-vous aux différentes techniques de portage physiologique adaptées aux nouveau-nés, sécurisantes pour bébé et confortables pour les parents.",
          icon: UserPlus,
          image: babyImage15
        }
      ]
    },
    urgences: {
      title: "Situations Courantes",
      tips: [
        {
          title: "Bronchiolite",
          content: "Mesures préventives et soins pour les nourrissons : lavage de nez régulier, humidification de l'air, position semi-assise. Consultez immédiatement en cas de difficultés respiratoires.",
          icon: Wind,
          image: babyImage16
        },
        {
          title: "Fièvre chez le Nourrisson",
          content: "Comment prendre la température correctement, quand s'inquiéter (>38°C avant 3 mois), et mesures de confort en attendant l'avis médical.",
          icon: Thermometer,
          image: babyImage17
        },
        {
          title: "Déshydratation",
          content: "Signes d'alerte chez le bébé : couches moins mouillées, fontanelle creusée, somnolence inhabituelle. Comment maintenir une hydratation optimale, particulièrement en cas de diarrhée.",
          icon: Droplets,
          image: babyImage18
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Navigation */}
      <NavBar />

      {/* Hero Section avec fond bleu ciel et nuages animés */}
      <div className="relative bg-sky-100 overflow-hidden">
        <div className="absolute inset-0">
          <div className="cloud cloud-1" />
          <div className="cloud cloud-2" />
          <div className="cloud cloud-3" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto text-center px-4 py-12 md:py-20">
          <h1 className="text-3xl md:text-5xl font-bold text-slate-800 mb-4 md:mb-6">
            Guide des Parents de Bébés
          </h1>
          <p className="text-lg md:text-xl text-slate-600">
            Conseils d'expertes et accompagnement personnalisé pour votre nouveau-né
          </p>
        </div>
      </div>

      {/* Contenu Principal */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* Catégories de conseils */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12">
          {Object.keys(categories).map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`p-4 rounded-lg transition-all shadow-md hover:shadow-lg ${
                activeCategory === cat
                  ? 'bg-amber-400 text-slate-800'
                  : 'bg-slate-50 text-slate-600 hover:bg-slate-100'
              }`}
            >
              {categories[cat].title}
            </button>
          ))}
        </div>

        {/* Conseils avec images de bébés */}
        <div className="grid md:grid-cols-3 gap-8">
          {categories[activeCategory].tips.map((tip, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg overflow-hidden transform transition hover:shadow-lg hover:scale-105"
            >
              <div className="aspect-w-16 aspect-h-9">
                <img 
                  src={tip.image} 
                  alt={tip.title} 
                  className="w-full h-48 object-cover" 
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <tip.icon className="w-10 h-10 text-amber-400 mr-3" />
                  <h3 className="text-xl font-semibold text-slate-800">{tip.title}</h3>
                </div>
                <p className="text-slate-600">{tip.content}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Section Informative avec des images */}
        <div className="mt-16 bg-sky-100 rounded-lg p-8 shadow-md overflow-hidden">
          <h2 className="text-2xl font-bold text-slate-800 mb-6">Accompagnement Personnalisé</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="text-xl text-slate-800 font-semibold">Notre Approche Spéciale Bébés</h3>
              <p className="text-slate-600">
                Chaque bébé est unique. Dès la sortie de maternité, nous adaptons nos conseils et techniques selon les besoins 
                spécifiques de votre nouveau-né. Un accompagnement sur mesure pour des 
                solutions efficaces pendant les premières semaines.
              </p>
              <div className="mt-4">
                <img src={babyImage4} alt="Soins du nouveau-né" className="rounded-lg shadow-md" />
              </div>
            </div>
            <div className="space-y-4">
              <h3 className="text-xl text-slate-800 font-semibold">Suivi Professionnel</h3>
              <p className="text-slate-600">
                Notre équipe de professionnelles de santé vous guide et vous conseille, tout en sachant 
                reconnaître les situations nécessitant une consultation médicale pour votre bébé.
              </p>
              <div className="mt-4">
                <img src={babyImage5} alt="Consultation professionnelle" className="rounded-lg shadow-md" />
              </div>
            </div>
          </div>
        </div>

        {/* Routine des bébés */}
        <div className="mt-16 bg-white rounded-lg p-8 shadow-md">
          <h2 className="text-2xl font-bold text-slate-800 mb-6">Routine des Bébés (0-6 mois)</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <img src={babyImage6} alt="Routine du bébé" className="rounded-lg shadow-md mb-4" />
            </div>
            <div>
              
              <h3 className="text-xl text-slate-800 font-semibold mb-3">Sortie de Maternité</h3>
              <ul className="text-slate-600 space-y-2 mb-20">
                <li className="flex items-start">
                  <span className="text-amber-400 mr-2">•</span>
                  Relais avec les parents et transmissions détaillées
                </li>
                <li className="flex items-start">
                  <span className="text-amber-400 mr-2">•</span>
                  Alimentation adaptée
                </li>
                <li className="flex items-start">
                  <span className="text-amber-400 mr-2">•</span>
                  Accompagnement du sommeil et mise en place des routines
                </li>
              </ul>
              <h3 className="text-xl text-slate-800 font-semibold mb-3">Surveillance et Soins</h3>
              <ul className="text-slate-600 space-y-2 mb-20">
                <li className="flex items-start">
                  <span className="text-amber-400 mr-2">•</span>
                  Surveillance du reflux, coliques, etc.
                </li>
                <li className="flex items-start">
                  <span className="text-amber-400 mr-2">•</span>
                  Soins spécifiques et adaptés au confort du bébé
                </li>
                <li className="flex items-start">
                  <span className="text-amber-400 mr-2">•</span>
                  Conseils personnalisés pour les parents
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Note de bas de page */}
        <div className="mt-16 text-center">
          <p className="text-slate-600 italic">
            Ces conseils sont donnés à titre indicatif. En cas de doute ou de symptômes persistants, 
            consultez votre pédiatre ou professionnel de santé.
          </p>
        </div>
      </div>

      {/* Styles pour les nuages */}
      <style jsx>{`
        .cloud {
          position: absolute;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 100px;
          animation: float 20s infinite linear;
        }

        .cloud-1 {
          width: 200px;
          height: 60px;
          top: 20%;
          left: -200px;
          animation-duration: 25s;
        }

        .cloud-2 {
          width: 150px;
          height: 45px;
          top: 40%;
          left: -150px;
          animation-duration: 30s;
          animation-delay: -10s;
        }

        .cloud-3 {
          width: 180px;
          height: 54px;
          top: 60%;
          left: -180px;
          animation-duration: 35s;
          animation-delay: -5s;
        }

        @keyframes float {
          from { transform: translateX(-100%); }
          to { transform: translateX(100vw); }
        }

        @media (max-width: 768px) {
          .cloud {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default ConseilsPage;